import type { BoxProps, TabsProps } from '@mui/material';
import { Box, Divider } from '@mui/material';
import type { PartialNever } from '@vy/utils';
import { isNotEmptyArray } from '@vy/utils';
import React from 'react';
import { SideNavbar } from '../../navigation/SideNavBar/SideNavbar';
import { VySearchBar } from '../surfaces/VySearchbar/VySearchBar';
import type { VyPageLayoutRequiredTabsProps } from './components/VyPageLayoutTabs';
import { VyPageLayoutTabs } from './components/VyPageLayoutTabs';

export type VyLayoutProps = {
  children: React.ReactNode;
  navigation?: React.ReactNode;
  tabsProps?: TabsProps;
  tabsAction?: React.ReactNode;
} & Omit<BoxProps, 'title'> &
  (Required<VyPageLayoutRequiredTabsProps> | PartialNever<VyPageLayoutRequiredTabsProps>);

export const VyLayout: React.FC<VyLayoutProps> = ({
  children,
  navigation,
  tabsProps,
  tabsAction,
  currentTab,
  tabs,
  ...props
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className="flex overflow-hidden h-screen">
      <div>
        <SideNavbar />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden">
        <VySearchBar />

        {navigation}

        {isNotEmptyArray(tabs) && (
          <>
            <Box sx={{ padding: '0 24px' }}>
              <VyPageLayoutTabs
                tabs={tabs}
                currentTab={currentTab}
                containerRef={containerRef}
                tabsAction={tabsAction}
                {...tabsProps}
              />
            </Box>
            <Divider />
          </>
        )}

        <Box
          ref={containerRef}
          component="main"
          className="flex-1 overflow-y-auto"
          sx={{
            width: '100%',
            backgroundColor: '#F5F6FA',
            padding: '14px 24px',
            ...props?.sx,
          }}
        >
          {children}
        </Box>
      </div>
    </div>
  );
};
